module.exports = __webpack_public_path__ + "assets/img/Group1128.ceb5c9cc.png";